import { renderPage } from "renderPage"
import { ClubPlanIndexPage } from "./Page"

renderPage({ component: ClubPlanIndexPage })
